import { Navigate, Outlet } from "react-router-dom"
import { useAuth } from "../../hooks/useAuth"
import type { User } from "../../types"

// El usuario se lee de localStorage de forma sincrona en el inicializador de
// useState del AuthProvider, asi que en el primer render ya se sabe si hay
// sesion: no hace falta un estado de carga ni un spinner intermedio.
export default function AuthGate({ allow }: { allow?: (user: User) => boolean }) {
  const { user } = useAuth()

  if (!user) return <Navigate to="/login" replace />
  if (allow && !allow(user)) return <Navigate to="/member" replace />

  return <Outlet />
}
